let $ = jQuery;
let breakpoints = require('../utilities/breakpoints');
// Import Greensock and it's plugins.
let CSSPlugin = require('../../node_modules/gsap/src/uncompressed/plugins/CSSPlugin');
let EasePack = require('../../node_modules/gsap/src/uncompressed/easing/EasePack');
let TweenLite = require('../../node_modules/gsap/src/uncompressed/TweenLite');

class MegaMenu {

  constructor() {
    this.currBP = breakpoints._current;
    this.$menuWrap = $('.js-topbar');
    this.$megaMenuToggles = $('.js-megamenu-toggle');
    this.$megaMenus = $('.js-megamenu');
    this.$megaMenu = $('#megamenus-wrapper');
    this.$megaMenuCloseBtns;
    this.btnsExist = false;
    this.loggedIn = $('body').hasClass('user-logged-in');

    this.addCloseMegaMenuBtns();

    // jQuery formatted selector to search for focusable items
    this.focusableElementsString = "a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable]";
    // Set all focusable elements within the megamenu to default state: tabindex = -1.
    this.toggleTabbing();

    $(window).resize(() => this.resizeMegaMenu()).trigger('resize');
  }

  resizeMegaMenu() {
    if (breakpoints.current === 'large' || breakpoints.current === 'xlarge') {

      if (this.$megaMenu.hasClass('open')) {
        this.setMegaMenuHeight();
      }

    }
    else {
      this.$megaMenu.css('padding-top', '');
      this.$menuWrap.css('padding-top', '');
    }
  }

  /*
    Loops through the megamenus - for each focusable elements in that megamenu,
    if that megamenu is active set tabindex to 0 otherwise set to -1.
  */
  toggleTabbing() {

    $.each(this.$megaMenus, (index, elem) => {
      var $menu = $(elem);
      var children = $menu.find('*');
      var tabindex = $menu.hasClass('js-active') ? 0 : -1;

      // get list of focusable items
      var focusableItems = children.filter(this.focusableElementsString);

      $.each(focusableItems, (index, elem) => {
        $(elem).attr('tabindex', tabindex);
      });
    });
  }

  closeMegaMenu() {
    if (this.$megaMenu.hasClass('open')) {
      this.$megaMenuToggles.filter('.js-active').trigger('click').focus();
    }
  }

  addCloseMegaMenuBtns() {
    this.btnsExist = true;

    $.each(this.$megaMenus, (index, elem) => {
      var closeBtn = this.getCloseBtnMarkup();
      $(elem).prepend(closeBtn);
    });

    this.$megaMenuCloseBtns = $('.js-megamenu-close-btn');
  }

  getCloseBtnMarkup() {
    var closeBtn = "<button class='megamenus__close-btn js-megamenu-close-btn' tabindex='0'>close menu</button>";
    return closeBtn;
  }

  handleNavClick(e) {
    var $target = $(e.target);
    var megamenuID = $target.data('megamenu');
    var menuHeight;
    var padding;

    $.each(this.$megaMenus, (index, elem) => {
      var $elem = $(elem);

      if ($elem.data('megamenu') !== megamenuID) {
        $elem.removeClass('js-active');
        this.$megaMenuToggles.eq(index).removeClass('js-active');
      }
      else if ($elem.data('megamenu') === megamenuID) {
        menuHeight = this.getMenuHeight();

        // Animate megamenu.
        if ($elem.hasClass('js-active')) {

          this.$megaMenuToggles.eq(index).removeClass('js-active');

          window.TweenLite.to(this.$megaMenu, .25, {
            'padding-top': 0,
            onComplete: () => {
              this.$megaMenu.removeClass('open');
            }
          });

          window.TweenLite.to(this.$menuWrap, .25, {'padding-top': 0});
        }
        else {

          this.$megaMenuToggles.eq(index).addClass('js-active');

          window.TweenLite.to(this.$megaMenu, .25, {
            'padding-top': menuHeight,
            onComplete: () => {
              this.setFocus($elem, this);
              this.$megaMenu.addClass('open');
            },
          });

          if (!this.loggedIn) {
            window.TweenLite.to(this.$menuWrap, .25, {'padding-top': menuHeight});
          }
        }

        $elem.toggleClass('js-active');
      }
    });

    // Set tabbing for megamenu.
    this.toggleTabbing();

    return false;
  }


  getMenuHeight() {
    var menuHeight = 0;

    $.each(this.$megaMenus, (index, elem) => {
      let $elem = $(elem);

      if ($(elem).outerHeight() > menuHeight) {
        menuHeight = $(elem).outerHeight();
      }
    });

    return menuHeight;
  }

  setMegaMenuHeight() {
    var menuHeight = this.getMenuHeight();

    window.TweenLite.to(this.$megaMenu, .25, {
      'padding-top': menuHeight
    });
  }

  setFocus(elem) {
    var $menu = $(elem);
    var $activeNavItem = this.$megaMenuToggles.filter('.js-active');

    // Toggle ability to focus megamenu with keyboard.
    this.toggleTabbing();

    // Set focus to button in megamenu that links to page.
    $menu.find('.js-megamenu-close-btn').focus();

    // Bind clicks for tabbing through megamenu.
    $menu.on('keydown', (e) => {

      // esc key press.
      if (e.keyCode == 27) {
        $activeNavItem.focus();
      }
      // tab or maj + tab.
      if (e.keyCode === 9) {
        // get list of all children elements in given object
        var children = $menu.find('*');

        // get list of focusable items
        var focusableItems = children.filter(this.focusableElementsString);

        // get currently focused item
        var focusedItem = $(document.activeElement);

        // get the number of focusable items
        var numberOfFocusableItems = focusableItems.length

        var focusedItemIndex = focusableItems.index(focusedItem);

        if (!e.shiftKey && (focusedItemIndex == numberOfFocusableItems - 1)) {
          focusableItems.get(0).focus();
          e.preventDefault();
        }
        else if (e.shiftKey && focusedItemIndex == 0) {
          focusableItems.get(numberOfFocusableItems - 1).focus();
          e.preventDefault();
        }
      }
    });
  }
}

module.exports = MegaMenu;
